import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { CustomerProvider } from "@/context/CustomerContext";

import Home from "@/pages/Home";
import ChiSono from "@/pages/ChiSono";
import Privacy from "@/pages/Privacy";
import EliminaAccount from "@/pages/EliminaAccount";
import Accedi from "@/pages/Accedi";
import Registrati from "@/pages/Registrati";
import Onboarding from "@/pages/Onboarding";

import QrLanding from "@/pages/customer/Landing";
import CustomerTable from "@/pages/customer/Table";
import CustomerMenu from "@/pages/customer/Menu";
import CustomerCart from "@/pages/customer/Cart";
import CustomerConto from "@/pages/customer/Conto";
import TenantPrivacy from "@/pages/customer/TenantPrivacy";
import DemoCucina from "@/pages/customer/DemoCucina";

import StaffLogin from "@/pages/staff/Login";
import Kds from "@/pages/staff/Kds";

import AdminHub from "@/pages/admin/Hub";
import AdminSettings from "@/pages/admin/Settings";
import AdminTables from "@/pages/admin/Tables";
import AdminMenu from "@/pages/admin/Menu";
import AdminItem from "@/pages/admin/Item";
import AdminAvailability from "@/pages/admin/Availability";
import AdminQr from "@/pages/admin/Qr";
import AdminUpsell from "@/pages/admin/Upsell";
import SuperAdmin from "@/pages/superadmin/SuperAdmin";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CustomerProvider>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/chi-sono" element={<ChiSono />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/elimina-account" element={<EliminaAccount />} />
              <Route path="/accedi" element={<Accedi />} />
              <Route path="/registrati" element={<Registrati />} />
              <Route path="/onboarding" element={<Onboarding />} />

              <Route path="/m/:slug" element={<QrLanding />} />
              <Route path="/m/:slug/tavolo" element={<CustomerTable />} />
              <Route path="/m/:slug/menu" element={<CustomerMenu />} />
              <Route path="/m/:slug/carrello" element={<CustomerCart />} />
              <Route path="/m/:slug/conto" element={<CustomerConto />} />
              <Route path="/m/:slug/privacy" element={<TenantPrivacy />} />
              <Route path="/m/:slug/cucina" element={<DemoCucina />} />

              <Route path="/staff/login" element={<StaffLogin />} />
              <Route path="/staff/kds" element={<Kds />} />

              <Route path="/admin" element={<AdminHub />} />
              <Route path="/admin/settings" element={<AdminSettings />} />
              <Route path="/admin/tables" element={<AdminTables />} />
              <Route path="/admin/menu" element={<AdminMenu />} />
              <Route path="/admin/item" element={<AdminItem />} />
              <Route path="/admin/availability" element={<AdminAvailability />} />
              <Route path="/admin/qr" element={<AdminQr />} />
              <Route path="/admin/upsell" element={<AdminUpsell />} />

              <Route path="/superadmin" element={<SuperAdmin />} />

              <Route path="*" element={<NotFound />} />
            </Routes>
          </CustomerProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
